import React from "react";
import { RenderKilogramo } from "Utils/renderField/renderReadField";
import Badge from "Utils/Badge/Badge";

export const DetallesSobranteTable = ({ trasladoDetalle }) => {
    const detalles =
        trasladoDetalle && trasladoDetalle.detalles_sobrante
            ? trasladoDetalle.detalles_sobrante
            : [];

    if (detalles.length === 0) return null;

    return (
        <React.Fragment>
            <h6 className="text-black mt-3">Kg secos sobrantes trasladados</h6>
            <div className="new-table-wrapper boleta-control-calidad__table-wrapper mt-2">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>PRODUCTO</th>
                            <th>ORIGEN</th>
                            <th>TARJETA</th>
                            <th>KG SECOS TRASLADADOS</th>
                            <th>KG SECOS FINALES ORIGEN</th>
                            <th>KG SECOS FINALES DESTINO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {detalles.map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td className="text-center text-nowrap boleta-control-calidad__table-ellipsis-cell">
                                        {item.producto_nombre || "N/A"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.es_conforme_bodega_origen
                                            ? "Conforme"
                                            : "No conforme"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.tarjeta_salida ? (
                                            <Badge
                                                text={`${
                                                    item.es_conforme_bodega_origen
                                                        ? "Roja"
                                                        : "Amarilla"
                                                } - ${item.tarjeta_salida}`}
                                                variant={
                                                    item.es_conforme_bodega_origen
                                                        ? "danger"
                                                        : "warning"
                                                }
                                            />
                                        ) : (
                                            "N/A"
                                        )}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={item.kg_secos_trasladados}
                                            decimalScale={2}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={item.kg_secos_finales_origen}
                                            decimalScale={2}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={
                                                item.kg_secos_finales_destino
                                            }
                                            decimalScale={2}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
